module.exports = __webpack_public_path__ + "img/重庆武隆芙蓉湖国家湿地公园@2x.7b4cc51c.png";